import React from 'react';
import { Button } from '@/components/ui/button';
import { Wind, Plus } from 'lucide-react';

const EFFECTS = [
  { type: 'blur', label: 'Blur', desc: 'Softens the whole frame.' },
  { type: 'sharpen', label: 'Sharpen', desc: 'Render-only — no live preview.' },
  { type: 'vignette', label: 'Vignette', desc: 'Darkens the frame edges.' },
  { type: 'glow', label: 'Glow', desc: 'Adds a soft bright glow.' },
];

/**
 * Browsable Effects catalog for the Main Editor sidebar (works with zero
 * media loaded). "Apply" performs a REAL add — it calls the exact same
 * `updateMasterItem` path EditorInspectorPanel uses — it is just disabled,
 * with an explanation, until a video clip is selected on the timeline.
 */
export function EditorEffectsCatalogPanel({ selectedItem, onApplyEffect }) {
  const canApply = selectedItem && selectedItem.item_type === 'video';
  return (
    <div className="space-y-2" data-testid="effects-catalog-panel">
      <p className="text-xs text-[#555E6E] uppercase tracking-wide flex items-center gap-1.5"><Wind className="h-3 w-3" />Browse Effects</p>
      {!canApply && (
        <p className="text-[11px] text-amber-400/80" data-testid="effects-catalog-hint">
          Select a video clip on the timeline to apply an effect to it.
        </p>
      )}
      {EFFECTS.map((eff) => (
        <div key={eff.type} className="p-2.5 rounded-lg bg-white/[0.03] border border-white/10 flex items-center justify-between gap-2" data-testid={`effects-catalog-item-${eff.type}`}>
          <div className="min-w-0">
            <p className="text-xs text-white font-medium">{eff.label}</p>
            <p className="text-[10px] text-[#555E6E] truncate">{eff.desc}</p>
          </div>
          <Button
            size="sm" variant="outline" className="h-7 text-[10px] border-white/10 shrink-0"
            disabled={!canApply}
            onClick={() => onApplyEffect(eff.type)}
            data-testid={`effects-catalog-apply-${eff.type}`}
          >
            <Plus className="h-3 w-3 mr-1" />Apply
          </Button>
        </div>
      ))}
      <p className="text-[10px] text-[#555E6E] pt-1">Fine-tune intensity, ordering and keyframes for applied effects in Properties once a clip is selected.</p>
    </div>
  );
}
